import { Action } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { NotificationModel } from '../../../../../common/notifications/Notifications.model';
import { ActionPayload, createAction } from '../../../../../web/common/actions/base.actions';
import {
  addNoteApi,
  alchemyFetchApi,
  alchemyFetchUnAuthSchemaApi,
  postAlchemyFeedbackAsync,
  authenticateUserApi,
  availableModalitiesV2FetchApi,
  createRequestApi,
  fetchAutoSuggestApi,
  fetchAutoSuggestApiV2,
  fetchBackgroundAuthUriApi,
  getAlchemyThemeRoutingDataApi,
  getCSRFFormTokenRetrievalApi,
  getDownloadAttachmentTokenApi,
  getInfoForClientTokenRetrievalApi,
  getRegionInfoApi,
  getRequestApi,
  getUploadAttachmentTokenApi,
  getUserLicensesApi,
  redirectForSignInLinkApi,
  searchRequestsApi,
  submitFeedbackApi,
  updateAttachmentsApi,
  updateContactsApi,
  uploadFileChunkApi,
  uploadFileMetadataApi,
  userInfoFetchAfterClientSignInApi,
  userInfoFetchApi,
  userNoticesFetchApi,
} from '../../../../../web/common/apis/contactUs.api';
import { ecsService } from '../../../../../web/common/apis/ecs.api';
import { httpUtils } from '../../../../../web/common/apis/httpUtils';
import {
  DiagnosticReference,
  NPSCampaign,
  StartupDafFeatureName,
  StartupDafIssueReference,
} from '../../../../../web/models/constants/getHelpConstants';
import { DafExecutingStatus } from '../../../../../web/models/getHelp/DafExecutingStatus';
import { GetHelpDiagnosticResponse } from '../../../../../web/models/getHelp/GetHelpDiagnosticResponse';
import { appContext } from '../../../../../web/models/getHelp/appContext';
import { EcsConfigurationResponse } from '../../../../../web/models/getHelp/ecsConfigurationResponse';
import { EmeraldUserType } from '../../../../../web/models/getHelp/emeraldUserType';
import {
  ExperienceMetaData,
  FlightingDecision,
  GetHelpExperienceResponse,
} from '../../../../../web/models/getHelp/experienceConfigurations';
import { GetAuthTokenPurpose } from '../../../../../web/models/getHelp/getAuthTokenPurpose';
import {
  AuthTokenRequest,
  AuthTokenResult,
  EmeraldSigninType,
  WebTokenRequestStatus,
} from '../../../../../web/models/getHelp/getHelpAuthToken';
import { GetHelpSMCGetUserLicensesResponse } from '../../../../../web/models/getHelp/getHelpSMCGetUserLicensesResponse';
import { License } from '../../../../../web/models/getHelp/license';
import { ICancelablePromise } from '../../../../../web/models/httpModels';
import { ResultType, TopResultData } from '../../../../../web/models/selfHelp';
import { getHelpLogger } from '../../../../../web/utils/getHelpLogger';
import { buildAuthTokenRequest, getParamFromRelativepath, getRandomGuidString, supportDafv1 } from '../../../../../web/utils/getHelputils';
import {
  SelfHelpStatus,
  addOrUpdateAwaMetaTag,
  captureContentUpdate,
  capturePageAction,
  collectTelemetry,
  logClientDebuggingEvent,
  logCustomError,
  reInitializeOneDsAsNeeded,
} from '../../../../../web/utils/oneDsUtil';
import * as ActionTypes from '../../../../models/actionTypes';
import {
  AlchemyInsightModel,
  AlchemyResult,
  AlchemyThemeRoutingData,
  AlchemyThemeModel,
  AuthInfo,
  AutoSuggestResult,
  AutoSuggestResultV2,
  ClientTokenRetrievalInfoModel,
  UserInfo,
} from '../../../../models/apiModels';
import { AwaMetaTagType, Environment, SourceApps } from '../../../../models/constants/constants';
import { IAppState } from '../../../../models/reduxState';
import {
  ClientAuthProvider,
  ClientPromptForLoginState,
  FormUrlEncodedHeaders,
  isMac,
  isUWP,
  makeAADAuthHeader,
  makeMSAAuthHeader,
  updateCustomerContacts,
} from '../../../../utilities';
import { showCoachmark, updateGetHelpConfig } from '../../../app/appActions';
import {
  isPostAlchemyFeedbackEnabledSelector,
  isThirdPartySelector,
  redirectForSignInLinkEnabledSelector
} from '../../../app/selectors/contactUsSelector';
import {
  isMultiInsightsEnabledSelector,
  isTopResultForSelfHelpEnabledSelector,
} from '../../../app/selectors/selfHelpSelectors';
import { SearchRequestsResponseModel } from '../../models/contactUsModels';
import { SurveyCheckBoxCategories } from '../../models/feedbackModels';
import { ModalityResponseModel, Region } from '../../models/modalityModels';
import { AttachmentData, AttachmentsConstants, ErrorCodes, ExtensionAttributeKeys, FreelanceRequest, UpdateContactsResponseModel } from '../../models/requestModels';
import { getHelpService } from '../../services/getHelpServices';
import { helpPaneServices } from '../../services/helpPaneServices';
import { macHelpPaneServices } from '../../services/macHelpPaneService';
import {
  attachmentActionAbortedAction,
  attachmentActionCompletedAction,
  cancelUploadAttachmentAction,
  flushAttachmentApiCancelTokenIdsAction,
  getAttachmentDownloadTokenAction,
  getDownloadAttachmentTokenError,
  getUploadAttachmentToken,
  getUploadAttachmentTokenError,
  getUploadAttachmentTokenSuccess,
  saveAttachmentApiCancelTokenIdAction,
  uploadAttachmentSuccess,
  uploadFileChunkError,
  uploadFileMetadataError,
  uploadFileMetadataSuccess,
} from '../actions/attachmentsActions';
import {
  fetchAutoSuggest,
  fetchAutoSuggestV2,
  setAutoSuggestResult,
  setAutoSuggestResultV2,
} from '../actions/autoSuggestActions';
import {
  authenticateUserSuccess,
  bypassThemeRouting,
  createRequest,
  createRequestError,
  createRequestSuccess,
  fetchAlchemyThemeRoutingDataSuccess,
  fetchAuthInfoError,
  fetchAvailableModalitiesV2,
  fetchAvailableModalitiesV2Success,
  fetchCSRFFormToken,
  fetchCSRFFormTokenError,
  fetchRedirectForSignInLinkSuccess,
  fetchUnAuthSchemaError,
  fetchUnAuthSchemaSuccess,
  fetchUserInfo,
  fetchUserInfoAfterSignInForClient,
  fetchUserInfoError,
  fetchUserInfoForClientSignIn,
  fetchUserInfoSuccess,
  getBackgroundAuthUri,
  getBackgroundAuthUriSuccess,
  getInfoForClientTokenRetrieval,
  getInfoForClientTokenRetrievalSuccess,
  getUWPAuthInfoSuccess,
  initializeAlchemyUnAuthSchemaFetch,
  redirectForSignInLinkFetch,
  removeAllPages,
  setUserIsSigningIntoClientApp,
  signInUser,
  signInUserBackground,
  signInUserIntoClientApp,
  signInUserIntoClientAppAggregator,
  updatePreferredLocale,
  updatePreferredTimeZone,
} from '../actions/modalitySectionActions';
import {
  addNote,
  addNoteError,
  addNoteSuccess,
  updateAttachments,
  updateAttachmentsError,
  updateAttachmentsSuccess,
  updateContacts,
  updateContactsError,
  updateContactsSuccess,
} from '../actions/requestDetailsActions';
import { submitFeedback, submitFeedbackError, submitFeedbackSuccess } from '../actions/requestFeedbackActions';
import {
  getRequest,
  getRequestError,
  getRequestSuccess,
  searchRequests,
  searchRequestsError,
  searchRequestsSuccess,
} from '../actions/requestHistoryActions';
import {
  fetchAlchemyError,
  fetchAlchemySuccess,
  fetchAlchemySuccessThirdParty,
  initializeAlchemyStateOnGetHelp,
  updateDialogId,
} from '../actions/selfHelpAlchemyActions';
import {
  fetchRegionInfo,
  fetchRegionInfoError,
  fetchRegionInfoSuccess,
  updateRequestVerificationToken,
} from '../actions/sharedStateActions';
import { dismissUserNotice, fetchUserNoticesError, fetchUserNoticesSuccess } from '../actions/userNoticeStateActions';
import { isAttachmentActionAbortedSelector } from '../selectors/attachmentsSelectors';
import { licensesSelector } from '../selectors/globalStateSelectors';
import { inEmsSession } from '../../../../../common/utils/commonUtilities';
import { LogType, LogHint } from '../../../../../web/models/emeraldLoggingRequest'; 

declare global {
  interface Window {
    chrome: any;
  }
}

export const dispatchFetchAutoSuggest = (query: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    _getState: () => IAppState
  ): Promise<void> => {
    dispatch(fetchAutoSuggest(query));
    try {
      const response: AutoSuggestResult = await fetchAutoSuggestApi(query);
      dispatch(setAutoSuggestResult(response !== null ? [response] : []));
    } catch (error) {
      dispatch(setAutoSuggestResult([]));
    }
  };
};

export const dispatchFetchAutoSuggestV2 = (query: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    _getState: () => IAppState
  ): Promise<void> => {
    dispatch(fetchAutoSuggestV2(query));
    try {
      const response: AutoSuggestResultV2 = await fetchAutoSuggestApiV2(query);
      dispatch(setAutoSuggestResultV2(response !== null ? response : {} as AutoSuggestResultV2));
    } catch (error) {
      dispatch(setAutoSuggestResultV2({} as AutoSuggestResultV2));
    }
  };
};

export const dispatchUserNoticesFetch = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();
    if (appState.ContactState.SharedState.isUserNoticeEnabled === true) {
      try {
        const response: AlchemyResult = await userNoticesFetchApi();
        if (response === null) {
          dispatch(fetchUserNoticesError());
        } else {
          dispatch(fetchUserNoticesSuccess(response.Insights));
        }
      } catch (error) {
        dispatch(fetchUserNoticesError());
      }
    }
  };
};

export const setTopResults = (result: AlchemyResult, getState: () => IAppState): void => {
  const appState: IAppState = getState();
  if (result && isTopResultForSelfHelpEnabledSelector(appState)) {
    const topResults: TopResultData[] = [];
    if (result.Insights && result.Insights.length > 0) {
      getHelpLogger.logAlchemyInsightsReceived(result);
      if (isMultiInsightsEnabledSelector(appState)) {
        result.Insights.forEach((insight: AlchemyInsightModel, index: number) => {
          if (!!insight.SolutionType && insight.SolutionType.toLowerCase() !== 'branching') {
            topResults.push({
              title: insight.Title,
              content: insight.Description,
              expanded: false,
              type: ResultType.Insight,
              url: null,
              bucketId: insight.BucketId,
              contentType: null,
              hideContent: index !== 0,
            });
          }
        });
      } else {
        const insight: AlchemyInsightModel = result.Insights[0];
        if (!!insight.SolutionType && insight.SolutionType.toLowerCase() !== 'branching') {
          topResults.push({
            title: insight.Title,
            content: insight.Description,
            expanded: false,
            type: ResultType.Insight,
            url: null,
            bucketId: insight.BucketId,
            contentType: null,
            hideContent: false,
          });
        }
      }
    } else if(!!result.AIInsights) {
      const alchemyGpt = result.AIInsights;
      topResults.push({
        title: null,
        content: alchemyGpt.GPTInsight,
        expanded: false,
        type: ResultType.AlchemyGPT,
        url: null,
        bucketId: null,
        contentType: null,
        hideContent: false
      });
    } else if (result.Solutions && result.Solutions.length > 0) {
      const solution = result.Solutions[0];
      topResults.push({
        title: solution.Title,
        content: solution.Description,
        expanded: false,
        type: ResultType.BCQR,
        url: solution.URI,
        contentType: solution.ContentType,
      });
      result.Solutions.shift();
    }

    if (topResults.length > 0) {
      result.TopResults = topResults;
    }
  }
};

export const dispatchAlchemyFetch = (
  searchQuery: string,
  actualQuery?: string,
  isSpecialQuery?: boolean,
  byPassPreProcess?: boolean
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(initializeAlchemyStateOnGetHelp(searchQuery));
    const appState: IAppState = getState();
    const sourceApp: SourceApps = appState.GlobalState.sourceApp;
    const isThirdParty: boolean = isThirdPartySelector(appState);
    if (!!sourceApp && (sourceApp.toLowerCase() === SourceApps.SurfaceApp || sourceApp.toLowerCase() === SourceApps.SurfaceApp2)) {
      if (window && window.chrome && window.chrome.webview && window.chrome.webview.postMessage) {
        window.chrome.webview.postMessage(searchQuery);
      }
    }
    const query = actualQuery ?? searchQuery;

    if (appState?.ContactState?.SelfHelpAlchemyState?.alchemyResults?.ThemeRoutingData) {
      getHelpLogger.logReloadCategories();
    }

    try {
      const response: AlchemyResult = await alchemyFetchApi(query, isSpecialQuery, byPassPreProcess);
      if (response === null) {
        logCustomError('No Alchemy result returned.');
        // Check soc2 here, will add to BRS later.
        if (!!sourceApp && sourceApp.toLowerCase() === SourceApps.SOC2) {
          const logHandlerTags = {
            content: {
              contentId: 'AlchemyFetchEmptyResponse',
              contentName: 'AlchemyFetchEmptyResponse',
              formnm: 'maxFunnel',
              areaName: 'selfHelpAlchemy',
            },
            behavior: 'CONTACT',
          };
          captureContentUpdate(logHandlerTags);
        }
        dispatch(fetchAlchemyError({} as AlchemyResult));
        await dispatchFetchAlchemyCompleted()(dispatch, getState, null);
      }
      getHelpLogger.logRoutingDataCallResult(!!response?.ThemeRoutingData, response?.CorrelationId, response?.Theme?.Name);
      if (!!response) {
        getHelpLogger.logResultsReceived(response);
        collectTelemetry({
          ContentId: 'AlchemyResultReceived', Type: LogType.ContentUpdate, Hint: LogHint.AlchemyResultReceived,
          Details: {
            theme: response.Theme?.Name ?? '',
            soutionCount: response.Solutions?.length ?? 0,
            solutionType: response.Solutions?.map(s => s.ContentType)?.reduce((res, curr) => {
              res[curr] = (res[curr] || 0) + 1;
              return res;
            }, {} as Record<string, number>) ?? '',
            insightCount: response.Insights?.length ?? 0,
            insightType: response.Insights?.map(i => i.SolutionType)?.reduce((res, curr) => {
              res[curr] = (res[curr] || 0) + 1;
              return res;
            }, {} as Record<string, number>) ?? '',
            incidentCount: response.Incidents?.length ?? 0,
            hasAIInsight: response.AIInsights != null,
            aimID: response.CorrelationId ?? '',
          }
        });
      }
      const { Incidents = [], Insights = [], Solutions = [], AIInsights = {} } = response;
      const isBcqrReturned: boolean = !!Solutions && Solutions.length > 0;
      const isInsightsReturned: boolean = !!Insights && Insights.length > 0;
      const isIncidentsReturned: boolean = !!Incidents && Incidents.length > 0;
      const isAIInsightsReturned = !!AIInsights && Object.keys(AIInsights).length > 0;
      if (!(isIncidentsReturned || isInsightsReturned || isBcqrReturned || isAIInsightsReturned)) {
        logCustomError(`No Alchemy result returned. CID: ${response.CorrelationId}`);
        const logHandlerTags = {
          content: {
            contentId: 'AlchemyFetchNoSolutionsResponse',
            contentName: 'AlchemyFetchNoSolutionsResponse',
            formnm: 'maxFunnel',
            areaName: 'selfHelpAlchemy',
            aimId: response.CorrelationId,
          },
          behavior: 'CONTACT',
        };
        captureContentUpdate(logHandlerTags);
      }
      // Check soc2 here, will add to BRS later.
      if (!!sourceApp && sourceApp.toLowerCase() === SourceApps.SOC2) {
        const logHandlerTags = {
          content: {
            contentId: 'AlchemyFetchHasSolutionsResponse',
            contentName: 'AlchemyFetchHasSolutionsResponse',
            formnm: 'maxFunnel',
            areaName: 'selfHelpAlchemy',
            correlationId: response.CorrelationId,
            bcqr: isBcqrReturned,
            insights: isInsightsReturned,
            incidents: isIncidentsReturned,
          },
          behavior: 'CONTACT',
        };
        captureContentUpdate(logHandlerTags);
      }

      if (isPostAlchemyFeedbackEnabledSelector(appState)) {
        postAlchemyFeedbackAsync({
          IsInsightRetrieved: isInsightsReturned,
          IsBcqrRetrieved: isBcqrReturned,
        });
      }

      setTopResults(response, getState);
      if (!isThirdParty) {
        dispatch(fetchAlchemySuccess(response));
        await dispatchFetchAlchemyCompleted()(dispatch, getState, null);
      } else {
        dispatch(fetchAlchemySuccessThirdParty(response));
      }
    } catch (error) {
      getHelpLogger.logAlchemyThemeRoutingDataReceivedFetchError(error);
      try {
        const topLocale = appContext.locale.substring(0, appContext.locale.lastIndexOf('-'));
        const url = `${appContext.distUrl}/assets/FallbackAlchemyResults/${topLocale}/otherTheme.json`;
        if (topLocale.toLowerCase() === 'zh' && appContext.locale.toLowerCase() !== 'zh-cn' && appContext.locale.toLowerCase() !== 'zh-hans-cn') {
          // Traditional Chinese is not supported
          throw error;
        }
        const fallbackAlchemyResult = await httpUtils.get<AlchemyResult>(url);
        dispatch(fetchAlchemyError(fallbackAlchemyResult));
        getHelpLogger.logAlchemyFetchApiErrorUsingFallbackTheme();
      } catch (error) {
        dispatch(fetchAlchemyError({} as AlchemyResult));
        getHelpLogger.logAlchemyFetchApiErrorUsingFallbackTheme(error);
      }
      await dispatchFetchAlchemyCompleted()(dispatch, getState, null);
    }
  };
};

export const dispatchAlchemyFetchUnAuthSchema = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(initializeAlchemyUnAuthSchemaFetch());
    try {
      const response: AlchemyResult = await alchemyFetchUnAuthSchemaApi();
      if (response === null) {
        logCustomError('Unauth schema not returned');
        dispatch(fetchUnAuthSchemaError());
      } else {
        const { Insights = [] } = response;
        if (!Insights.length) {
          logCustomError(`Unauth schema insight not returned. CID: ${response.CorrelationId}`);
        }
        getHelpLogger.logUnAuthPayloadReceived(response.Insights[0]);
        dispatch(fetchUnAuthSchemaSuccess(response));
      }
    } catch (error) {
      dispatch(fetchUnAuthSchemaError());
    }
  };
};

export const dispatchFetchUserInfoSuccess = (response: UserInfo): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(fetchUserInfoSuccess(response));
    if (response && response.Cid) {
      await dispatchSignInSuccess(response)(dispatch, getState, null);
    }
  };
};

export const dispatchFetchUserInfoAfterSignInForClient = (response: UserInfo): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(fetchUserInfoAfterSignInForClient(response));
    if (response && response.Cid) {
      await dispatchSignInSuccess(response)(dispatch, getState, null);
    }
  };
};

export const dispatchUserInfoFetch = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(fetchUserInfo());
    try {
      const response: UserInfo = await userInfoFetchApi();
      reInitializeOneDsAsNeeded(response, new SelfHelpStatus(getState()));
      await dispatchFetchUserInfoSuccess(response)(dispatch, getState, null);
    } catch (error) {
      dispatch(fetchUserInfoError());
    }
  };
};

export const dispatchRedirectForSignInLink = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();
    if (redirectForSignInLinkEnabledSelector(appState)) {
      dispatch(redirectForSignInLinkFetch());
      try {
        const response: string = await redirectForSignInLinkApi();
        dispatch(fetchRedirectForSignInLinkSuccess(response));
      } catch (error) {
        // handle error if needed
      }
    }
  };
};

export const dispatchFetchAvailableModalitiesV2 = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(fetchAvailableModalitiesV2());
    try {
      const response: ModalityResponseModel = await availableModalitiesV2FetchApi();
      dispatch(fetchAvailableModalitiesV2Success(response));
    } catch (error) {
      dispatch(fetchAvailableModalitiesV2Success({
        AgentModalities: { 'Modalities': [] },
        NonAgentModalities: { 'Modalities': [] },
        RegionInfo: [],
        ShowAskCommunity: true,
        IsDfC: false,
      }));
      getHelpLogger.logSupportError(`dispatchFetchAvailableModalitiesV2 - ${error.message ?? ''}`);
      // Log this error for other entry points?
    }
  };
};

export const dispatchUpdatePreferredTimeZone = (preferredLocal: string): ThunkAction<void, IAppState, null, Action<string>> => {
  return (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): void => {
    dispatch(updatePreferredTimeZone(preferredLocal));
  };
};

export const dispatchUpdatePreferredLocale = (preferredLocal: string): ThunkAction<void, IAppState, null, Action<string>> => {
  return (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): void => {
    dispatch(updatePreferredLocale(preferredLocal));
  };
};

export const dispatchGetRegionInfo = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(fetchRegionInfo());
    try {
      const response: Region[] = await getRegionInfoApi();
      dispatch(fetchRegionInfoSuccess(response));
    } catch (error) {
      dispatch(fetchRegionInfoError());
    }
  };
};

export const dispatchCreateRequest = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(createRequest());
    try {
      const response: FreelanceRequest = await createRequestApi();
      const state: IAppState = getState();
      if (isPostAlchemyFeedbackEnabledSelector(state)) {
        postAlchemyFeedbackAsync({
          TicketCreated: true,
          IsBcqrRetrieved: state.ContactState.SelfHelpAlchemyState.areSolutionsPresent,
          IsInsightRetrieved: state.ContactState.SelfHelpAlchemyState.areInsightsPresent,
        });
      }
      dispatch(createRequestSuccess(response));
    } catch (error) {
      dispatch(createRequestError(error));
    }
  };
};

export const dispatchSearchRequests = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(searchRequests());
    try {
      const response: SearchRequestsResponseModel = await searchRequestsApi();
      if (response) {
        dispatch(searchRequestsSuccess(response.Results));
      } else {
        logCustomError('searchRequestsApi - result is null');
        dispatch(searchRequestsError());
      }
    } catch (error) {
      logCustomError(`dispatchSearchRequests - error caught, errorMessage: ${error.message}`);
      dispatch(searchRequestsError());
    }
  };
};

export const dispatchGetRequest = (requestId: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(getRequest(requestId));
    try {
      const response: FreelanceRequest = await getRequestApi(requestId);
      if (response) {
        dispatch(getRequestSuccess(response));
      } else {
        logCustomError('dispatchGetRequest - result is null');
        dispatch(getRequestError());
      }
    } catch (error) {
      if (!!error) {
        logCustomError(`dispatchGetRequest - error caught, errorMessage: ${error.message}`);
      }
      dispatch(getRequestError());
    }
  };
};

export const dispatchUpdateAttachments = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(updateAttachments());
    try {
      const response: FreelanceRequest = await updateAttachmentsApi();
      if (response) {
        const appState: IAppState = getState();
        const dirtyRequest: FreelanceRequest = { ...appState.ContactState.RequestDetailsState.dirtyRequest };
        dispatch(updateAttachmentsSuccess(dirtyRequest));
      } else {
        logCustomError('Update Attachments - was unsuccessful');
        dispatch(updateAttachmentsError());
      }
    } catch (error) {
      logCustomError(`dispatchUpdateAttachments - error caught, errorMessage: ${error.message}`);
      dispatch(updateAttachmentsError());
    }
  };
};

export const dispatchAddNote = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(addNote());
    try {
      const response: FreelanceRequest = await addNoteApi();
      if (response) {
        const appState: IAppState = getState();
        const dirtyRequest: FreelanceRequest = { ...appState.ContactState.RequestDetailsState.dirtyRequest };
        dispatch(addNoteSuccess(dirtyRequest));
      } else {
        logCustomError('Add Note - was unsuccessful');
        dispatch(addNoteError());
      }
    } catch (error) {
      logCustomError(`dispatchAddNote - error caught, errorMessage: ${error.message}`);
      dispatch(addNoteError());
    }
  };
};

export const dispatchUpdateContacts = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(updateContacts());
    try {
      const response: UpdateContactsResponseModel = await updateContactsApi();
      if (response) {
        const appState: IAppState = getState();
        const dirtyRequest: FreelanceRequest = { ...appState.ContactState.RequestDetailsState.dirtyRequest };
        // checking for IsUpdateContactsSuccessful only because rave will update even if extensionAttributes fails
        // we'll move to read mode and show error message if extensionAttribute update fails
        if (response.IsUpdateContactsSuccessful) {
          updateCustomerContacts(dirtyRequest);
          dispatch(updateContactsSuccess(dirtyRequest, response));
        } else {
          dispatch(updateContactsError());
        }
      } else {
        logCustomError('Update Contact Details - was unsuccessful');
        dispatch(updateContactsError());
      }
    } catch (error) {
      logCustomError(`dispatchUpdateContacts - error caught, errorMessage: ${error.message}`);
      dispatch(updateContactsError());
    }
  };
};

export const dispatchFetchBackgroundAuthUriSuccessAgave = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    getState: () => IAppState
  ): Promise<void> => {
    const appState: IAppState = getState();
    const env: Environment = appState.GlobalState.environment;
    const isOutlookDotComEms = inEmsSession() && Environment.OutlookDotCom === env;
    if (Environment.agavePane === env || Environment.SOC === env || isOutlookDotComEms) {
      let nIntervId: number | NodeJS.Timeout;
      let isFetchingUserInfo = false; // To track if fetching user info is in progress

      // Todo brook: verify if we need appState.ContactState.ModalitySectionState.hasThirdPartyCookiesEnabled
      if (!nIntervId && appState.ContactState.ModalitySectionState.hasThirdPartyCookiesEnabled) {
        await dispatchUserInfoFetch()(dispatch, getState, null);

        // In order to capture the interval id we must have a local function.  Any function returned from non-local function
        // won't capture the local variable.  Instead it captures the non-local function argument which will always be undefined
        // and the timer will never be cleared.
        let monitorSignin = async (): Promise<void> => {
          const isSignedIn = getState().ContactState.ModalitySectionState.isSignedIn;
          if (isSignedIn) {
            clearInterval(nIntervId);
          } else if (!isFetchingUserInfo) {
            try {
              isFetchingUserInfo = true; // Set the flag before calling dispatchUserInfoFetch
              await dispatchUserInfoFetch()(dispatch, getState, null);
            }
            catch (error) {
              logCustomError(`dispatchFetchBackgroundAuthUriSuccessAgave - error caught, errorMessage: ${error.message}`);
            }
            finally {
              isFetchingUserInfo = false; // Reset the flag after the call completes
            }
          }
        };
        nIntervId = setInterval(monitorSignin, 1000);
      }
    }
  };
};

export const dispatchSignInUser = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(signInUser());
    await dispatchFetchBackgroundAuthUriSuccessAgave()(dispatch, getState, null);
  };
};

export const dispatchGetBackgroundAuthUriSuccess = (authUri: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(getBackgroundAuthUriSuccess(authUri));
    await dispatchFetchBackgroundAuthUriSuccessAgave()(dispatch, getState, null);
    await dispatchFetchBackgroundAuthUriSuccessUWP()(dispatch, getState, null);
  };
};

export const dispatchFetchBackgroundAuthUriSuccessUWP = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();
    if (isUWP(appState.GlobalState.namespace)) {
      await dispatchAuthenticateUser(appState.ContactState.ModalitySectionState.authInfo)(dispatch, getState, null);
    }
  };
};

export const dispatchFetchClientAuthTokenInfoSuccess = (authInfo: AuthInfo): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(getUWPAuthInfoSuccess(authInfo));
    const state = getState();
    if (isUWP(state.GlobalState.namespace)) {
      dispatchFetchBackgroundAuthUri(authInfo.provider === 'ADAL' ? 'AAD' : 'MSA');
    }
  };
};

export const dispatchGetInfoForClientTokenRetrieval = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(getInfoForClientTokenRetrieval());
    try {
      const response: ClientTokenRetrievalInfoModel = await getInfoForClientTokenRetrievalApi();
      await dispatchGetInfoForClientTokenRetrievalSuccess(response)(dispatch, getState, null);
    } catch (error) {
      logCustomError(`dispatchGetInfoForClientTokenRetrieval - error caught, errorMessage: ${error.message}`);
    }
  };
};

export const dispatchGetInfoForClientTokenRetrievalSuccess = (
  clientTokenRetrievalInfoModel: ClientTokenRetrievalInfoModel
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState = getState();
    dispatch(getInfoForClientTokenRetrievalSuccess(clientTokenRetrievalInfoModel));
    if (isUWP(appState.GlobalState.namespace)) {
      try {
        const result: AuthInfo = await (window as any).Assistance.getAuthInfoAsync(
          {
            resourceId: clientTokenRetrievalInfoModel.AADAppId,
            authorityUrl: clientTokenRetrievalInfoModel.SignInEndpoint,
          },
          { targetUrl: clientTokenRetrievalInfoModel.SiteDomain, policy: clientTokenRetrievalInfoModel.Encryption }
        );
        await dispatchFetchClientAuthTokenInfoSuccess(result)(dispatch, getState, null);
      } catch (error) {
        dispatch(fetchAuthInfoError(error));
      }
    }
  };
};

export const dispatchAuthenticateUserSuccess = (): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(authenticateUserSuccess());
    // Todo: Brook namespace and version were not set inside authenticateUserSuccess when FETCH_CSRF_FORM_TOKEN was triggered, check if they should be undefined
    await dispatchGetCSRFFormTokenRetrieval('', '')(dispatch, getState, null);
  };
};

export const dispatchAuthenticateUser = (authInfo: AuthInfo): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();
    dispatch(signInUserBackground(appState.ContactState.ModalitySectionState.authInfo));
    try {
      await authenticateUserApi(authInfo);
      // Todo: Brook authenticateUserSuccess dispatches FETCH_CSRF_FORM_TOKEN check if this is correct
      dispatchAuthenticateUserSuccess();
    } catch (error) {
      logCustomError(`dispatchAuthenticateUser - error caught, errorMessage: ${error.message}`);
    }
  };
};

export const dispatchFetchBackgroundAuthUri = (provider: string): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(getBackgroundAuthUri(provider));
    try {
      const response: string = await fetchBackgroundAuthUriApi(provider);
      dispatchGetBackgroundAuthUriSuccess(response);
    } catch (error) {
      logCustomError(`dispatchFetchBackgroundAuthUri - error caught, errorMessage: ${error.message}`);
    }
  };
};

export const dispatchSignInSuccess = (userInfo: UserInfo): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const state: IAppState = getState();
    // If userInfo is defined update the dom meta tag with the provider.
    if (userInfo && userInfo.Provider) {
      addOrUpdateAwaMetaTag(AwaMetaTagType.AuthType, userInfo.Provider);
    }
    // If Routing is enabled, will set modality stage to theme dropdown. For AAD users, skip theme dropdown and go to modalityOptions stage to display tenant admin message
    if (
      state.ContactState.ModalitySectionState.alchemyThemeRoutingEnabled &&
      !state.ContactState.ModalitySectionState.isOrgId
    ) {
      // After sign in, we should reset the stack so that ServiceRequestPageManager decides which page to begin with.
      // Usually there will be signinsection page in stack, which needs to be removed.
      dispatch(removeAllPages());

      // If alchemyThemeRoutingEnabled is false (For non-SMC) and second fetchUserInfo is successful, call fetchAvailableModalitiesV2 which will also skip theme dropdown selection.
      // SMC AAD users will also go to here, skip theme dropdown and go to modalityOptions stage to display tenant admin message.
      // contactSearchedQuery check is to differentiate the second userInfo call after filling out a query and click on get help button.
      // IsDeepLinkQuery check is to differentiate between userinfo calls for deep link scenario, IsDeepLinkQuery is true for first call and then set to false for second call via alchemy success action
    } else if (
      !!state.ContactState.SharedState.contactSearchedQuery &&
      !state.ContactState.SharedState.isDeepLinkQuery
    ) {
      await dispatchFetchAvailableModalitiesV2()(dispatch, getState, null);
    }
  };
};

export const dispatchFetchAlchemyCompleted = (): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();
    if (appState.ContactState.SharedState.isUnAuthSupportEnabled) {
      await dispatchFetchAvailableModalitiesV2()(dispatch, getState, null);
      // For Get help, fetch user info is triggered by UpdateAuthToken callback, no need to fetch user info again
    } else if (appState.GlobalState.environment !== Environment.GetHelp) {
      await dispatchUserInfoFetch()(dispatch, getState, null);
    }
  };
};

export const dispatchUpdateSignInEpic = (): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();
    if (appState.ContactState.SharedState.clientPromptForLoginState === ClientPromptForLoginState.SUCCESS) {
      await dispatchSignInUser()(dispatch, getState, null);
    } else {
      dispatch(setUserIsSigningIntoClientApp(false));
    }
  };
};

export const dispatchUserInfoFetchAfterClientSignIn = (): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    dispatch(fetchUserInfoForClientSignIn());
    try {
      const response: UserInfo = await userInfoFetchAfterClientSignInApi();
      logClientDebuggingEvent(
        300,
        'maxFunnel',
        'signInButton',
        'modalitiesSection',
        'contactUsDispatchers.ts',
        'dispatchUserInfoFetchAfterClientSignIn',
        'clientUserInfoFetch',
        `User Info fetch success after client login? ${!!(response && response.Cid)}`
      );
      reInitializeOneDsAsNeeded(response, new SelfHelpStatus(getState()));
      await dispatchFetchUserInfoAfterSignInForClient(response)(dispatch, getState, null);
    } catch (error) {
      dispatch(fetchUserInfoError());
    }
  };
};

export const dispatchFetchCSRFFormToken = (
  appVer?: string,
  headers?: Record<string, string>,
  clientPromptLoginState?: ClientPromptForLoginState
): ThunkAction<Promise<boolean>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<boolean> => {
    const appState: IAppState = getState();
    dispatch(
      fetchCSRFFormToken(
        headers,
        appVer,
        appState.GlobalState.namespace,
        appState.GlobalState.version,
        clientPromptLoginState
      )
    );
    const response: boolean = await dispatchGetCSRFFormTokenRetrieval(
      appState.GlobalState.namespace,
      appState.GlobalState.version
    )(dispatch, getState, null);
    return response;
  };
};

export const dispatchGetCSRFFormTokenRetrieval = (
  namespace: string,
  version: string
): ThunkAction<Promise<boolean>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    _getState: () => IAppState
  ): Promise<boolean> => {
    try {
      const response: string = await getCSRFFormTokenRetrievalApi(namespace, version);
      dispatch(updateRequestVerificationToken(response));
      return true;
    } catch (error) {
      if (error) {
        logCustomError(`dispatchGetCSRFFormTokenRetrieval - error caught, errorMessage: ${error.message}`);
      }
      dispatch(fetchCSRFFormTokenError());
      return false;
    }
  };
};

export const dispatchSignInUserIntoClientApp = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    getState: () => IAppState
  ): Promise<void> => {
    dispatch(signInUserIntoClientApp());
    const clientWindow = (window as any);
    const appState: IAppState = getState();
    const tokenInfoModel = appState.ContactState.ModalitySectionState.clientTokenRetrievalInfoModel;
    logClientDebuggingEvent(
      300,
      'maxFunnel',
      'signInButton',
      'modalitiesSection',
      'contactUsDispatchers.ts',
      'dispatchSignInUserIntoClientApp',
      'clientLoginResult',
      `Initiating login with ${JSON.stringify(tokenInfoModel)}`
    );
    const service = isMac(appState.GlobalState.namespace)
      ? macHelpPaneServices(logClientDebuggingEvent).getClientToken(clientWindow, null)
      : helpPaneServices(logClientDebuggingEvent).getClientToken(clientWindow.external, tokenInfoModel);
    try {
      const authInfo: AuthInfo = await service;
      await dispatchSignInUserIntoClientAppAggregator(authInfo)(dispatch, getState, null);
    } catch (error) {
      if (error) {
        logCustomError(`dispatchSignInUserIntoClientApp - error caught, errorMessage: ${error.message}`);
      }
      dispatch(setUserIsSigningIntoClientApp(false));
    }
  };
};

export const dispatchSignInUserIntoClientAppAggregator = (authInfo: AuthInfo): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    getState: () => IAppState
  ): Promise<void> => {
    dispatch(signInUserIntoClientAppAggregator(authInfo));
    const appState: IAppState = getState();
    const tokenInfoModel: ClientTokenRetrievalInfoModel = appState.ContactState.ModalitySectionState.clientTokenRetrievalInfoModel;
    const token: string = authInfo.token;
    const loginProvider: string = authInfo.provider;
    const headers: Record<string, string> = {
      'User-Context': tokenInfoModel.UserContext,
      'Content-Type': FormUrlEncodedHeaders['Content-Type'],
    };
    const isValidToken: boolean = !!token;
    if (isValidToken) {
      const authHeader: string =
        loginProvider === ClientAuthProvider.AAD ? makeAADAuthHeader(token) : makeMSAAuthHeader(token);
      headers['Authorization'] = authHeader;
    }
    const clientPromptLoginState: ClientPromptForLoginState = isValidToken
      ? ClientPromptForLoginState.SUCCESS
      : ClientPromptForLoginState.FAILED_OR_CANCELLED;
    logClientDebuggingEvent(
      300,
      'maxFunnel',
      'signInButton',
      'modalitiesSection',
      'contactUsDispatchers.ts',
      'dispatchSignInUserIntoClientAppAggregator',
      'clientLoginResult',
      `${clientPromptLoginState}`
    );

    try {
      const isSuccessful: boolean = await dispatchFetchCSRFFormToken(
        appState.GlobalState.appVer,
        headers,
        clientPromptLoginState
      )(dispatch, getState, null);
      if (clientPromptLoginState === ClientPromptForLoginState.SUCCESS && isSuccessful) {
        await dispatchUserInfoFetchAfterClientSignIn()(dispatch, getState, null);
      }
      dispatch(setUserIsSigningIntoClientApp(false));
    } catch (error) {
      if (error) {
        logCustomError(`dispatchSignInUserIntoClientAppAggregator - error caught, errorMessage: ${error.message}`);
      }
      dispatch(setUserIsSigningIntoClientApp(false));
    }
  };
};

export const dispatchGetUploadAttachmentToken = (
  workspaceId: string,
  requestId: string,
  chunkSizeInMB: number,
  doc: File
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    getState: () => IAppState
  ): Promise<void> => {
    try {
      dispatch(attachmentActionAbortedAction(false));
      dispatch(getUploadAttachmentToken(workspaceId, requestId, chunkSizeInMB, doc));

      const response: string = await getUploadAttachmentTokenApi(workspaceId, requestId);
      const isAttachmentAborted: boolean = isAttachmentActionAbortedSelector(getState());

      if (!!isAttachmentAborted) {
        // Handle canceling upload
        dispatch(attachmentActionCompletedAction());
      } else {
        dispatch(getUploadAttachmentTokenSuccess(response, chunkSizeInMB, doc, requestId));
        await dispatchUploadFileMetadata(response, chunkSizeInMB, doc, requestId)(dispatch, getState, null);
      }
    } catch (error) {
      if (error) {
        logCustomError(`dispatchGetUploadAttachmentToken - error caught, errorMessage: ${error.message}`);
      }
      dispatch(getUploadAttachmentTokenError(ErrorCodes.AttachmentUploadFileError, requestId));
    }
  };
};

export const dispatchUploadFileMetadata = (
  token: string,
  chunkSizeInMB: number,
  doc: File,
  requestId: string
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    getState: () => IAppState
  ): Promise<void> => {
    try {
      dispatch(flushAttachmentApiCancelTokenIdsAction());
      const uploadFileMetadataApiPromise: ICancelablePromise<AttachmentData> = uploadFileMetadataApi(token, chunkSizeInMB, doc, requestId);
      dispatch(saveAttachmentApiCancelTokenIdAction(uploadFileMetadataApiPromise.cancelTokenId));

      const response: AttachmentData = await uploadFileMetadataApiPromise;
      const isAttachmentAborted: boolean = isAttachmentActionAbortedSelector(getState());

      if (!!isAttachmentAborted) {
        // Handle canceling upload
        dispatch(attachmentActionCompletedAction());
      } else {
        dispatch(uploadFileMetadataSuccess(response, token, requestId, chunkSizeInMB, doc));
        await dispatchUploadFileChunk(response, token, requestId, chunkSizeInMB, doc)(dispatch, getState, null);
      }
    } catch (error) {
      // Handle both error and upload cancel here
      const isAttachmentAborted: boolean = isAttachmentActionAbortedSelector(getState());
      if (!isAttachmentAborted) {
        logCustomError(`uploadFileMetadataApi - error caught, errorMessage: ${error.message}, statusCode: ${error.response?.status}`);
        requestId = requestId || '';
        const logHandlerTags = {
          content: {
            contentId: 'AttachmentMetadataUploadFailure',
            contentName: 'AttachmentMetadataUploadFailure',
            formnm: 'maxFunnel',
            fileName: 'contactUs.api.ts',
            areaName: 'Attachments',
            message: 'upload failure',
            requestId: requestId,
          },
          behavior: 'CONTACT',
        };
        captureContentUpdate(logHandlerTags);
        dispatch(uploadFileMetadataError(ErrorCodes.AttachmentUploadFileError, requestId));
      }
    }
  };
};

export const dispatchUploadFileChunk = (
  attachmentData: AttachmentData,
  token: string,
  requestId: string,
  chunkSizeInMB: number,
  doc: File
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    getState: () => IAppState
  ): Promise<void> => {
    const appState: IAppState = getState();
    const chunkSizeInB: number = chunkSizeInMB * 1024 * 1024;
    const fileSizeinB: number = doc.size;
    const numberOfChunks: number = Math.ceil(fileSizeinB / chunkSizeInB);
    let blobStartIndex = 0;
    let blobEndIndex: number = Math.min(chunkSizeInB, fileSizeinB);
    let remainingBlobSize: number = fileSizeinB;
    let chunkRequestsList: ICancelablePromise<void>[] = [];
    const chunksPerBucket: number = appState.ContactState.AttachmentsState.attachmentsConfig.ChunksPerBucket;
    const numberOfBuckets: number = Math.ceil(numberOfChunks / chunksPerBucket);
    let chunkOffset = 0;
    let remainingChunks: number = numberOfChunks;
    let isUploadSuccess = false;
    try {
      for (let currentBucket = 0; currentBucket < numberOfBuckets; currentBucket++) {
        const requestRemainsPerBucket: number = Math.min(remainingChunks, chunksPerBucket);
        let cancelTokenId = '';
        for (let currentChunk = chunkOffset; currentChunk < chunkOffset + requestRemainsPerBucket; currentChunk++) {
          const currentBlob: Blob = doc.slice(blobStartIndex, blobEndIndex);
          remainingBlobSize -= blobEndIndex - blobStartIndex;
          blobStartIndex = blobEndIndex;
          blobEndIndex = blobStartIndex + Math.min(chunkSizeInB, remainingBlobSize);
          const currentBlobForm = new FormData();
          currentBlobForm.append(doc.name + AttachmentsConstants.ChunkTag + currentChunk, currentBlob);
          const uploadFileChunkApiPromise: ICancelablePromise<void> = uploadFileChunkApi(attachmentData, token, requestId, currentBlobForm, currentChunk);
          cancelTokenId = uploadFileChunkApiPromise.cancelTokenId;
          dispatch(saveAttachmentApiCancelTokenIdAction(cancelTokenId));
          chunkRequestsList.push(uploadFileChunkApiPromise);
        }
        await Promise.all(chunkRequestsList);
        chunkRequestsList = [];
        chunkOffset += chunksPerBucket;
        remainingChunks -= chunksPerBucket;
      }
      isUploadSuccess = true;
    } catch (error) {
      logCustomError(`uploadFileChunkApi - error caught, errorMessage: ${error.message}, statusCode: ${error.response?.status}`);
      requestId = requestId || '';
      const cwsId = attachmentData ? attachmentData.CwsId : '';
      const logHandlerTags = {
        content: {
          contentId: 'AttachmentChunkUploadFailure',
          contentName: 'AttachmentChunkUploadFailure',
          formnm: 'maxFunnel',
          fileName: 'contactUs.api.ts',
          areaName: 'Attachments',
          message: 'upload failure',
          requestId: requestId,
          cwsId: cwsId,
        },
        behavior: 'CONTACT',
      };
      captureContentUpdate(logHandlerTags);
    }

    !!isUploadSuccess
      ? dispatch(uploadAttachmentSuccess(attachmentData, requestId))
      : dispatch(uploadFileChunkError(ErrorCodes.AttachmentUploadFileError, requestId));
  };
};

export const dispatchCancelUploadAttachment = (
  requestId: string
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    _getState: () => IAppState
  ): Promise<void> => {
    const appState: IAppState = _getState();
    const cancellationTokenList: string[] = appState.ContactState.AttachmentsState.cancelTokenIdsList;
    await httpUtils.cancelAllRequests(cancellationTokenList);
    dispatch(cancelUploadAttachmentAction(requestId));
    dispatch(attachmentActionAbortedAction(true));
    dispatch(attachmentActionCompletedAction());
  };
};

export const dispatchGetDownloadAttachmentToken = (cwsId: string, requestId: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(getAttachmentDownloadTokenAction(cwsId, requestId));
    try {
      await getDownloadAttachmentTokenApi(cwsId, requestId);
    } catch (error) {
      if (error) {
        logCustomError(`dispatchGetDownloadAttachmentToken - error caught, errorMessage: ${error.message}`);
      }
      dispatch(getDownloadAttachmentTokenError());
    }
  };
};

export const dispatchGetAlchemyThemeRoutingData = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    try {
      const response: AlchemyThemeRoutingData = await getAlchemyThemeRoutingDataApi();
      const theme: AlchemyThemeModel = {
        Confidence: 0,
        Name: "Other",
        SecondaryTheme: null,
        SecondaryThemeConfidence: 0
      }
      // create modified response
      const modifiedResponse: AlchemyResult = {
        Theme: theme,
        Solutions: [],
        Insights: [],
        Incidents: [],
        CorrelationId: response.CorrelationId,
        DebugInfo: '',
        ThemeRoutingData: response,
        TopResults: [],
        AIInsights: null,
        Query: ''
      };
      dispatch(fetchAlchemySuccess(modifiedResponse));
      dispatch(fetchAlchemyThemeRoutingDataSuccess());
    } catch (error) {
      if (error) {
        logCustomError(`dispatchGetAlchemyThemeRoutingData - error caught, errorMessage: ${error.message}`);
      }
    }
  };
};

export const dispatchSubmitFeedback = (
  requestData: FreelanceRequest,
  ratingText: string,
  requestId: string,
  checkBoxes: SurveyCheckBoxCategories
): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    dispatch(submitFeedback(requestData, ratingText, requestId, checkBoxes));
    try {
      const response: boolean = await submitFeedbackApi(requestData, checkBoxes);
      if (response) {
        dispatch(submitFeedbackSuccess(requestId));
      } else {
        logCustomError('Submit feedback - was unsuccessful');
        dispatch(submitFeedbackError(requestId));
      }
    } catch (error) {
      if (error) {
        logCustomError(`dispatchSubmitFeedback - error caught, errorMessage: ${error.message}`);
      }
      dispatch(submitFeedbackError(requestId));
    }
  };
};

export const dispatchOnNotificationsRender = (notification: NotificationModel): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (): Promise<void> => {
    const renderOverrideTags = {
      content: {
        contentId: `userNotice_${notification.id}`,
        contentName: `userNotice_${notification.id}`,
        formnm: 'maxFunnel',
        areaName: 'userNotice',
      },
      behavior: 'SHOW',
    };
    captureContentUpdate(renderOverrideTags);
  };
};

export const dispatchDismissUserNotice = (notification: NotificationModel): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    const dismissId = `notice-close-mark_${notification.id}`;
    const dismissOverrideTags = {
      content: { contentId: dismissId, contentName: dismissId, formnm: 'maxFunnel', areaName: 'userNotice' },
      behavior: 'HIDE',
    };
    capturePageAction(null, dismissOverrideTags);
    dispatch(dismissUserNotice(notification.id));
  };
};

const updateMetaDataInAppContext = (expInfo: ExperienceMetaData): void => {
  appContext.featureFlightList = expInfo?.FeatureFlightSelectedList;
  appContext.systemInfo = expInfo?.SystemInfo;
  appContext.deviceId = expInfo?.DeviceId;
  appContext.manufacturer = expInfo.Manufacturer;
  appContext.manufacturerLink = expInfo.ManufacturerLink;
};

export const dispatchUpdateGetHelpConfigurations = (
  configuration: GetHelpExperienceResponse
): ThunkAction<void, IAppState, null, Action<ActionPayload>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<ActionPayload>>,
    _getState: () => IAppState
  ): Promise<void> => {
    getHelpLogger.logUpdateConfiguration(configuration);

    let selectedFeatureList: string[] | null = null;
    if (!!configuration.FeatureFlightSelectedList && Object.keys(configuration.FeatureFlightSelectedList).length > 0) {
      selectedFeatureList = Object.keys(configuration.FeatureFlightSelectedList).filter(
        (value: string) => configuration.FeatureFlightSelectedList[value] === FlightingDecision.SelectedForFlighting
      );
    }

    const meta: ExperienceMetaData = {
      FeatureFlightSelectedList: selectedFeatureList,
      SystemInfo: configuration.SystemInfo,
      Overrides: configuration.Overrides,
      DeviceId: configuration.DeviceId,
      Manufacturer:
        getParamFromRelativepath(configuration.ContextResponse?.LandingPageRelativePath, 'manufacturer') ?? '',
      ManufacturerLink:
        getParamFromRelativepath(configuration.ContextResponse?.LandingPageRelativePath, 'manufacturersupportlink') ??
        '',
    };

    if (!!meta && !!meta.Overrides?.SmcAuthUrlBase && meta.Overrides.SmcAuthUrlBase.length > 0) {
      appContext.environment.smcAuthUrlBase = meta?.Overrides.SmcAuthUrlBase;
      if (inEmsSession()) {
        appContext.environment.emsAuthUrlBase = meta?.Overrides.SmcAuthUrlBase;
      }
    }

    dispatch(updateGetHelpConfig(meta));

    if (appContext.appSupportsAuth && appContext.emeraldUserType === EmeraldUserType.Consumer) {
      const authCommand: AuthTokenRequest = buildAuthTokenRequest(GetAuthTokenPurpose.SignInValidation, EmeraldSigninType.SilentOnly);
      notifyParent(JSON.stringify(authCommand));

      if (supportDafv1 && selectedFeatureList?.includes(StartupDafFeatureName)) {
        const sessionResponse: GetHelpDiagnosticResponse = await getHelpService.getDiagnosticSessionAsync(
          DiagnosticReference.ProblemKey,
          StartupDafIssueReference
        );
        if (sessionResponse !== null) {
          appContext.startupCheckDafSessionId = sessionResponse.SessionId;
          dispatch({ type: ActionTypes.SET_STARTUP_DIAG_STATUS, payload: DafExecutingStatus.Executing });
          notifyParent(
            JSON.stringify({
              command: 'RunDiagnostic',
              context: {
                sessionId: sessionResponse.SessionId,
                autohealId: sessionResponse.AutohealId,
              },
            })
          );
        } else {
          dispatch({ type: ActionTypes.SET_STARTUP_DIAG_STATUS, payload: DafExecutingStatus.Disabled });
        }
      } else {
        dispatch({ type: ActionTypes.SET_STARTUP_DIAG_STATUS, payload: DafExecutingStatus.Disabled });
      }
    }

    updateMetaDataInAppContext(meta);
    // Todo: Brook Update logs
    // logDeviceIdVerification();
    if (appContext.degradedExperience) {
      // Todo: Brook Update logs
      // logDegradedExperience();
    }
  };
};

export const dispatchGetHelpTokenReceived = (
  response: string
): ThunkAction<void, IAppState, null, Action<ActionPayload>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<ActionPayload>>,
    getState: () => IAppState
  ): Promise<void> => {
    let authResult: AuthTokenResult = null;
    if (response !== null && response.length !== 0) {
      authResult = JSON.parse(response);
    }

    // If any errors
    if (!authResult || !authResult.Token || authResult.ResponseStatus !== WebTokenRequestStatus.Success) {
      // const message = authResult?.ResponseErrorMessage ?? 'no error message received';
      // const status = !!authResult?.ResponseStatus ? authResult.ResponseStatus.toString() : 'no response status received';
      // const errortext = `ErrorMessage: ${message}, Status: ${status}`;
      // logAuthError(errortext);

      /*
       * The GetHelp entrypoint will send an auth token on app load via the external event ExternalCommand.UpdateAuthToken.
       * In the case that the user is not logged in we will get one of the following ResponseStatus codes and so we do not
       * want to trigger a sign in error.
       *
       *   WebTokenRequestStatus.Success
       *   WebTokenRequestStatus.UserCancel
       *   WebTokenRequestStatus.AccountSwitch
       *   WebTokenRequestStatus.UserInteractionRequired
       *
       * When the user clicks the "can't sign in" link we want to show the user the branching dialog instead of an
       * error message.  This is managed by <SignInSection> which uses errorOnSignIn to determine whether to show
       * branching or an error message.  The error message is intended to be shown when there is a server side error
       * when trying to sign the user in.
       */
      const serverSideAuthError: boolean =
        authResult?.ResponseStatus === WebTokenRequestStatus.AccountProviderNotAvailable ||
        authResult?.ResponseStatus === WebTokenRequestStatus.ProviderError;

      if (serverSideAuthError) {
        dispatch({
          type: ActionTypes.ERROR_ON_SIGN_IN,
          errorOnSignIn: true,
        });
      } else if (authResult?.Purpose === GetAuthTokenPurpose.SignInValidation) {
        dispatch({
          type: ActionTypes.FETCH_USERINFO_NOT_SIGNEDIN,
        });
      }

      // Todo: Brook - will this logic be executed, since we have !authResult check above
      if (!!authResult?.Purpose) {
        switch (authResult.Purpose) {
          case GetAuthTokenPurpose.SignInValidation:
            await dispatchUserLicensesAndNotificationsFetch()(dispatch, getState, null);
            break;
          default:
            break;
        }
      }
    } else {
      // logAuthResponseReceived(authResult);
      const authInfo: AuthInfo = {
        provider: ClientAuthProvider.MSA,
        token: authResult.Token,
      };
      dispatch(getUWPAuthInfoSuccess(authInfo));
      try {
        const userInfo: UserInfo = await userInfoFetchApi();
        reInitializeOneDsAsNeeded(userInfo, new SelfHelpStatus(getState()));
        await dispatchFetchUserInfoSuccess(userInfo)(dispatch, getState, null);
      } catch (error) {
        dispatch(fetchUserInfoError());
      }
      if (!!authResult?.Purpose) {
        switch (authResult.Purpose) {
          case GetAuthTokenPurpose.SignInValidation:
          case GetAuthTokenPurpose.SignInAndConsumerCategoryOptions:
            await dispatchUserLicensesAndNotificationsFetch(authResult.Token)(dispatch, getState, null);
            break;
          default:
            break;
        }
      }
    }
  };
};

export const dispatchGetHelpTokenError = (
  result: string
): ThunkAction<void, IAppState, null, Action<ActionPayload>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<ActionPayload>>,
    _getState: () => IAppState
  ): Promise<void> => {
    if (!!result && result.includes(GetAuthTokenPurpose.SignInValidation)) {
      // logSilentLoginFailed(true);
      dispatch({
        type: ActionTypes.FETCH_USERINFO_NOT_SIGNEDIN,
      });
      return;
    }

    // const purpose = result?.includes('Purpose:') ? result.split(':')[1].trim() : '';
    // logAuthError('Auth Exception - ' + result, purpose);
    dispatch({
      type: ActionTypes.ERROR_ON_SIGN_IN,
      errorOnSignIn: true,
    });
  };
};

export const dispatchGetUserLicenses = (): ThunkAction<void, IAppState, null, Action<ActionPayload>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<ActionPayload>>,
    _getState: () => IAppState
  ): Promise<void> => {
    // logUserLicenseApiAttempt();
    const transactionId: string = getRandomGuidString();

    try {
      const licenseResponse: GetHelpSMCGetUserLicensesResponse = await getUserLicensesApi(transactionId);
      const licenses: License[] = licenseResponse?.Licenses ?? [];
      // const userPuid = !!licenseResponse?.IdentityValue ? `p:${licenseResponse.IdentityValue}` : '';

      // userPuid should be populated by userInfo
      // Todo: Brook udpate userPuid if needed
      // dispatch(createAction(actionTypes.UPDATE_USER_ID, userPuid));
      dispatch(createAction(ActionTypes.UPDATE_LICENSES, licenses));
      // logCaptureUserLicenses(userPuid, licenses, transactionId);
    } catch (error) {
      dispatch(createAction(ActionTypes.UPDATE_LICENSES, [] as License[]));
      // Temporary logging used for investigation. This will be removed after investigation
      // logUserLicenseCallError(error);
    }
  };
};

const getEcsConfiguration = async (
  dispatch: ThunkDispatch<IAppState, null, Action<ActionPayload>>,
  getState: () => IAppState
): Promise<void> => {
  // Temporary logging used for investigation. This will be removed after investigation
  // logEcsApiAttempt();
  const appState: IAppState = getState();
  const licenses: License[] | null = licensesSelector(appState);
  const productIds: string[] = [...new Set(licenses?.filter((x: License) => !!x?.ProductId)?.map((x: License) => x.ProductId))];

  try {
    const ecsConfiguration: EcsConfigurationResponse = await ecsService.getEcsConfiguration(productIds);

    dispatch(createAction(ActionTypes.UPDATE_ECS_CONFIGURATION, ecsConfiguration));
    // logGetEcsConfiguration();
  } catch (error) {
    // Temporary logging used for investigation. This will be removed after investigation
    // logEcsCallError(error);
  }
};

export const dispatchUserLicensesAndNotificationsFetch = (token?: string): ThunkAction<void, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();
    if (appState.GlobalState.getHelpConfig) {
      const getUserLicensesFlag: boolean | undefined = appState.GlobalState.getHelpConfig?.FeatureFlightSelectedList?.includes(
        NPSCampaign.FeatureUserLicenses
      );
      const ecsEnabledFlag: boolean = ecsService.ecsIsEnabled(getState);

      dispatch(createAction(ActionTypes.UPDATE_LICENSES, [] as License[]));
      dispatch(createAction(ActionTypes.UPDATE_ECS_CONFIGURATION, null));

      if (!!token && getUserLicensesFlag && appContext.emeraldUserType === EmeraldUserType.Consumer) {
        await dispatchGetUserLicenses()(dispatch, getState, null);
      }

      if (ecsEnabledFlag) {
        await getEcsConfiguration(dispatch, getState);
      }

      await dispatchUserNoticesFetch()(dispatch, getState, null);
    }
  };
};

export const dispatchBypassThemeRouting = (dialogId: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, getState: () => IAppState): Promise<void> => {
    const appState: IAppState = getState();

    // This dispatcher is triggered from ContactUsFooter.ts when the user clicks "Contact Support" button. The bypassThemeRouting function will check if the dialog is whitelisted.
    // And if it is, it will autofill the categories. Then we will fetch available modalities within the current dispatcher. And then in ServiceRequestPageManager, we will skip to modalities page
    // if the categories are autofilled. If not, then will go to category dropdown page as usual.

    // Will only be used for GetHelp endpoint for now. In the future it might/will be used for rest of the endpoints.

    // Add logs here for bypassing theme routing for 1DS in future

    if (appState.GlobalState.getHelpConfig?.FeatureFlightSelectedList?.includes('BypassCategories')) {
      await dispatch(bypassThemeRouting(dialogId));
      if (!!appState.ContactState.ModalitySectionState?.draftRequest?.ExtensionAttributes[ExtensionAttributeKeys.ThemeL1]) {
        await dispatchFetchAvailableModalitiesV2()(dispatch, getState, null);
      }
    }
  };
};

export const dispatchUpdateDialogId = (dialogId: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (dispatch: ThunkDispatch<IAppState, null, Action<string>>, _getState: () => IAppState): Promise<void> => {
    await dispatch(updateDialogId(dialogId));
  };
};

export const dispatchShowCoachmark = (): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
  return async (
    dispatch: ThunkDispatch<IAppState, null, Action<string>>,
    _getState: () => IAppState
  ): Promise<void> => {
    dispatch(showCoachmark());
  };
};